module.exports = __webpack_public_path__ + "static/img/9.c7af8dfd.png";